<template>
  <div class="user-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id" :class="items.class">
        <div :class="['user-guide-mask', 'user-guide-mask-' + items.type]" v-if="items.needMask">
          <template v-if="items.type === 'default'">
            <div
              class="user-guide-top"
              :style="{
                height: (items.highlightArea.top + isMsgTop) + 'px'
              }"></div>
            <div
              class="user-guide-left"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                width: items.highlightArea.left + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-right"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                left: items.highlightArea.left + items.highlightArea.width + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-bottom"
              :style="{
                top: items.highlightArea.top + isMsgTop + items.highlightArea.height + 'px'
              }"></div>
          </template>
        </div>
        <div
          class="user-guide-content"
          :style="items.type === 'modal' ? {
            top: '50%',
            left: (clientWidth + items.modalArea.width + items.guideWidth) / 2 + 'px',
          } : {
            top: items.guideArea.top + (items.type === 'modal' ? 0 : isMsgTop) + 'px',
            left: items.guideArea.left + 'px',
          }">
          <div class="user-guide-main flex justify-between">
            <div v-if="items.content" v-html="items.content"></div>
            <i class="el-icon-close size16 gj-ml8 gj-pointer" @click="setUserGuideState" style="color: rgba(255, 255, 255, 0.4)"></i>
          </div>
          <div class="flex justify-between align-center gj-mt12">
            <div>{{bootSteps}}/3</div>
            <div v-if="items.btnList.length" class="btnList flex">
              <div v-if="items.btnList.includes('video')" class="gj-pointer">参考教程<i class="el-icon-arrow-right"></i></div>
              <div v-if="items.btnList.includes('next')" @click="nextStep()" class="gj-pointer completeBtn">下一步</div>
              <div v-if="items.btnList.includes('complete')" @click="nextStep()" class="gj-pointer completeBtn">完成任务</div>
            </div>
          </div>
          <div v-if="items.guideDirection === 'right'" class="user-guide-point-right" :style="{ width: items.guideWidth + 'px', right: `-${items.guideWidth}px` }">
            <div class="user-guider-line"></div>
          </div>
          <div v-if="items.guideDirection === 'bottom'" class="user-guide-point-bottom" :style="{ height: items.guideWidth + 'px', bottom: `-${items.guideWidth}px`, left: '50%', marginLeft: `-4px` }">
            <div class="user-guider-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH} from "@/store/mutation-types";
import appUserGuideSucc from "@/views/components/user-guide-succ-modal/user-guide-succ-modal"
import {mapGetters} from "vuex";
import { userGuideMixin } from "@/minxins"; 
const clientWidth = document.body.clientWidth;
const clientHeight = document.body.clientHeight;
export default {
  name: "new-user-guide",
  data() {
    return {
      bootSteps: 0,
      data: [],
      isMsgTop: 0,
      clientWidth,
      taskItem: null
    }
  },
  mixins: [userGuideMixin],
  computed: {
    ...mapGetters({
      isMsgsGlobal: 'isMsgsGlobal',
      userGuideState: 'userGuideState',
    })
  },
  watch: {
    isMsgsGlobal: {
      handler(val) {
        this.isMsgTop = val ? 34 : 0;
      },
      immediate: true
    },
    userGuideState: {
      handler(newState, oldState) {
        if(!newState && oldState) this.cancel();
      }
    }
  },
  created() {
    this.bootSteps = 1;
    this.taskItem = this.userGuideTaskItem;
    this.initData();
  },
  methods: {
    initData() {
      const isNavHorizontal = localStorage.getItem('NAV_STATE') !== 'vertical';
      const subtractHeight =  isNavHorizontal ? 0 : 40;
      const addWidth =  isNavHorizontal ? 0 : 60;
      this.data = [
        {
          id: 1,
          class: "user-guide-one",
          type: 'default',
          needMask: true,
          highlightArea: {
            width: clientWidth - 60 - addWidth,
            height: clientHeight - 144 - 80 - 34 + subtractHeight,
            top: 144 - subtractHeight,
            left: 30 + addWidth,
          },
          guideArea: {
            top: 0,
            left: (clientWidth - 402 + addWidth)/2 ,
          },
          guideDirection: 'bottom',
          guideWidth: 30,
          content: "插件安装后，您可以在此查看所有店铺插件的状态，只有状态为在线时，系统才可以正常同步数据哦<br />如果您未安装插件，则系统无法为您记录流量数据并生成流量分析图表，也无法提供财务报表哦~",
          btnList: ['next'],
        },
        {
          id: 3,
          class: "user-guide-two",
          type: 'default',
          needMask: true,
          highlightArea: {
            width: 168,
            height: 34,
            top: 101 - subtractHeight,
            left: clientWidth - 40 - 160 ,
          },
          guideArea: {
            top: 72 - subtractHeight,
            left: clientWidth - 40 - 160 - 460,
          },
          guideDirection: 'right',
          guideWidth: 60,
          content: "为保证您在系统可以同步分析销售与流量数据，或查看财务维度的利润报表数据，快来安装积加云插件吧~",
          btnList: ['complete'],
        }
      ]
    },
    prevStep() {
      this.bootSteps--;
    },
    nextStep(step = null) {
      if(step) {
        this.bootSteps = step
      } else {
        this.bootSteps++;
      }
      if(this.bootSteps === 2) {
        this.$router.push({path:'/tool/cloud-plugin-report', query: {step: this.bootSteps}})
      } else if(this.bootSteps === 4) {
        this.completeTask()
      }
    },
    temporarilyClosed() { // 暂时关闭，不退出引导状态
      this.bootSteps = 0;
    },
    async completeTask() {
      const taskItem = this.taskItem;
      const { finishTaskList } = await this.getNextTask(taskItem?.taskTypeCode, taskItem?.taskChildCode, true);
      if(!finishTaskList) {
        this.$message.error(`检测发现未安装插件,无法完成任务,请安装插件完成任务！`)
      } else {
        if(taskItem.taskStatus != 'COMPLETED') {
          this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
          this.$gjCreate(appUserGuideSucc,{
            global: true,
            props: {
              id: taskItem?.taskTypeCode
            }
          })
        } else {
          this.setUserGuideState()
        }
      }
    },
    setUserGuideState() {
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$emit('closeModal')
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
    },
  }
}
</script>
<style lang="scss" scoped>
.user-guide-mask {
  .user-guide-top, .user-guide-left, .user-guide-right, .user-guide-bottom {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.4);
  }
}
.user-guide-mask-menu {
  position: absolute;
    top: 75px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2100;
    background: rgba(0, 0, 0, 0.4);
}

.user-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 12px 16px;
  background: #4994FC;
  box-sizing: border-box;
  border-radius: 4px;
  width: 402px;
  font-size: 12px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  position: relative;
  position: absolute;
  z-index: 2200;
  .user-guide-point-right {
    position: absolute;
    right: -40px;
    top: 48%;
    .user-guider-line {
      width: 100%;
      height: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -4px;
      }
    }
  }
  .user-guide-point-bottom {
    position: absolute;
    left: -40px;
    bottom: 0;
    .user-guider-line {
      height: 100%;
      width: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        bottom: -4px;
        left: -3px;
      }
    }
  }
}
.knowBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
.completeBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  background: #FFFFFF;
  color: #4994FC;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
</style>